import { createContext } from 'react';

import { IDBDowngradeRequest } from 'hooks';
import { IDBProject } from 'interfaces';

export interface IPlanContext {
  daysRemaining: number | undefined;
  downgradeRequest: IDBDowngradeRequest | undefined;
  kanziProject: IDBProject | undefined;
  planPeriod: string | undefined;
}

export const PlanContext = createContext<IPlanContext>({
  daysRemaining: undefined,
  kanziProject: undefined,
  planPeriod: undefined,
  downgradeRequest: undefined,
});

// eslint-disable-next-line import/no-default-export
export default PlanContext;
